import FlagCS from "modules/ui/Icons/FlagCS";
import FlagDE from "modules/ui/Icons/FlagDE";
import FlagEN from "modules/ui/Icons/FlagEN";

export const offices = [
    {
        title: 'contacts.prague.title',
        street: 'contacts.prague.street',
        city: 'contacts.prague.city',
        country: 'contacts.prague.country',
        icon: FlagCS
    },
    {
        title: 'contacts.berlin.title',
        street: 'contacts.berlin.street',
        city: 'contacts.berlin.city',
        country: 'contacts.berlin.country',
        icon: FlagDE
    },
    {
        title: 'contacts.raleigh.title',
        street: 'contacts.raleigh.street',
        city: 'contacts.raleigh.city',
        country: 'contacts.raleigh.country',
        icon: FlagEN
    },
] as const;

export enum Office {
    PRAGUE = 'prague',
    BERLIN = 'berlin',
}
